// extracted by mini-css-extract-plugin
export var descriptionBlock = "cw_kc";
export var errorMessageContainer = "cw_j8";
export var headerBlock = "cw_j9";
export var iconStyle = "cw_kb";